import { textTransforms } from 'shared/constants/customization';
import { TextTransformOption } from 'types/graphql';

export const getTextTransformStyle = (option: TextTransformOption): string | null =>
  textTransforms.find((transform) => transform.value === option)?.style ?? null;
